/* ===== Card hover bar: size selection + enable ATC (form version) ===== */
document.addEventListener('click', (e) => {
  const pill = e.target.closest('.card-hover-bar .size-pill:not(.size-pill--disabled)');
  if (!pill) return;

  e.preventDefault();
  e.stopPropagation();

  const bar   = pill.closest('.card-hover-bar');
  bar.querySelectorAll('.size-pill').forEach(p => p.classList.remove('is-selected'));
  pill.classList.add('is-selected');

  const form  = bar.querySelector('.hover-add-to-cart-form');
  const input = form?.querySelector('.selected-variant-id');
  const atc   = form?.querySelector('.add-to-cart-btn');

  if (input && atc) {
    input.value = pill.dataset.variantId;  // set variant for the form
    atc.disabled = false;                  // enable ATC
    atc.classList.remove('disabled');
  }
});

/* ===== Fix for eye icon (Quick Add modal) ===== */
document.addEventListener('click', (e) => {
  // Check if the eye icon button was clicked
  const viewButton = e.target.closest('.card-hover-bar .view-link');
  if (!viewButton) return;

  e.preventDefault();
  e.stopPropagation();

  const productUrl = viewButton.dataset.productUrl;
  const modalOpener = viewButton.closest('modal-opener');
  
  if (!modalOpener) return;

  const modalId = modalOpener.dataset.modal;
  const modal = document.querySelector(modalId);
  
  if (!modal) {
    console.error('Modal not found:', modalId);
    return;
  }

  // Find the content info container
  const modalContent = modal.querySelector('.quick-add-modal__content-info');
  
  if (!modalContent) {
    console.error('Modal content container not found');
    return;
  }

  // Show loading state
  modalContent.innerHTML = '<div style="padding: 2rem; text-align: center;">Loading...</div>';
  
  // Open the modal first
  document.body.classList.add('overflow-hidden');
  modal.setAttribute('open', '');
  
  // Extract product ID from modal ID (e.g., "QuickAdd-123456789" -> "123456789")
  const productId = modalId.replace('#QuickAdd-', '');
  
  // Fetch using the correct Dawn theme URL structure
  const fetchUrl = `${productUrl}?variant=${productId}&section_id=quick-add`;
  
  fetch(fetchUrl)
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      
      // Try multiple selectors to find the content
      let productElement = html.querySelector(`#QuickAddInfo-${productId}`);
      
      if (!productElement) {
        productElement = html.querySelector('[id^="QuickAddInfo-"]');
      }
      
      if (!productElement) {
        // If still not found, try getting the main product form
        productElement = html.querySelector('.product-form');
      }
      
      if (productElement) {
        modalContent.innerHTML = productElement.innerHTML;
        
        // Focus on the dialog
        const dialog = modal.querySelector('[role="dialog"]');
        if (dialog) {
          trapFocus(modal, dialog);
        }
      } else {
        // Fallback: just load the entire body content
        const mainContent = html.querySelector('main') || html.body;
        modalContent.innerHTML = mainContent.innerHTML;
      }
      
      window.pauseAllMedia();
    })
    .catch(error => {
      console.error('Error loading quick add content:', error);
      modalContent.innerHTML = '<div style="padding: 2rem; text-align: center;">Error loading product</div>';
    });
});

/* Navigate when clicking the bottom content area (outside the actual <a>) */
document.addEventListener('click', (e) => {
  const content = e.target.closest('.product-card-wrapper .card > .card__content');
  if (!content) return;

  // Don't hijack if user clicked a real interactive element
  if (e.target.closest('a, button, [role="button"], input, select, textarea, label')) return;

  const link =
    content.querySelector('a.full-unstyled-link[href*="/products/"]') ||
    content.querySelector('a[href*="/products/"]');

  if (link && link.href) {
    e.preventDefault();
    window.location.assign(link.href);
  }
});
